export const websiteData = {
  title: 'What type of website was it?',
  buttons: [
    { label: 'A shopping website', id: 'shopping', isFocused: true },
    { label: 'A website selling cryptocurrency', id: 'cryptocurrency' },
    { label: 'An investment/savings account website', id: 'investment' },
    {
      label: 'A website selling insurance e.g. car insurance',
      id: 'insurance',
    },
    {
      label: 'An online form asking for my details',
      id: 'online-form',
    },
    { label: 'Other', id: 'other' },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/bd5407b3db75-tool-icon-web-question-dark.jpg',
  },
}

export const messageData = {
  title: 'What was the message about?',
  buttons: [
    {
      label: "My friend's account was hacked and the hacker was asking me to send them money",
      id: 'hacked-account-send-money',
      isFocused: true,
    },
    {
      label: "My friend's account was hacked and the hacker was asking me to send them vouchers",
      id: 'hacked-account-send-vouchers',
    },
    { label: 'Advertising a product or investment service', id: 'advertising' },
    {
      label: 'Offering me a vaccine',
      id: 'offering-vaccine',
    },
    { label: 'Other', id: 'other' },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/d2e8f20713c2-tool-icon-web-shop.jpg',
  },
}
